module.exports = __webpack_public_path__ + "static/media/icon_139.ada1ce3c.svg";